import { PlanStack } from '@zapier/design-system-revenue/src/types';
import { BillingInterval } from '@zapier/design-system-revenue/src/graphql-types';
import { planIds } from './planIds';

const commonProps = {
  __typename: 'PlanV2' as 'PlanV2',
  allowCompanies: false,
  hasAutoReplay: true,
  hasPaths: true,
  hasMultiStepZaps: true,
  hasPremiumApps: true,
  hasTeams: false,
  isInPlanGroup: true,
  hasMeteredBilling: false,
  tiers: [],
  description: 'Advanced tools to take your work to the next level.',
  features: [
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Multi-step Zaps',
      tooltip:
        'Multi-Step Zaps let a single Trigger (e.g. new email lead) perform as many Actions (e.g. add to my CRM) as you want.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: '/apps?filter=premium',
      name: 'Unlimited Premium Apps',
      tooltip:
        'Premium apps are select apps that are exclusively available to users on a paid plans.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Filters',
      tooltip:
        'Filters tell your Zaps to run only if your data matches certain criteria.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Formatters',
      tooltip:
        'Formatters let you tweak numbers, dates, and text in over a dozen ways to get it in the format you need.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Custom Integrations',
      tooltip:
        'Build powerful, custom integrations that connect any app with Webhooks by Zapier.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Custom Logic - Paths',
      tooltip:
        'Build advanced workflows using branching logic to run different actions based on conditions you decide.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Auto Replay',
      tooltip:
        'Intelligently retries any Task failures due to temporary errors or downtime for you.',
    },
  ],
  type: 'Professional',
  zaps: -1,
  zapsRunInterval: 2,
};

export const professionalPlanStackMock: PlanStack = {
  __typename: 'PlanTaskGrouping',
  id: 'Professional',
  plans: [
    {
      ...commonProps,
      amount: 58800,
      interval: BillingInterval.year,
      id: planIds.PROFESSIONAL_2000_YEARLY,
      name: 'Professional (2,000 Tasks)',
      tasks: 2000,
    },
    {
      ...commonProps,
      amount: 6125,
      interval: BillingInterval.month,
      id: planIds.PROFESSIONAL_2000_MONTHLY,
      name: 'Professional (2,000 Tasks)',
      tasks: 2000,
    },
    {
      ...commonProps,
      amount: 106800,
      interval: BillingInterval.year,
      id: planIds.PROFESSIONAL_5000_YEARLY,
      name: 'Professional (5,000 Tasks)',
      tasks: 5000,
    },
    {
      ...commonProps,
      amount: 11125,
      interval: BillingInterval.month,
      id: planIds.PROFESSIONAL_5000_MONTHLY,
      name: 'Professional (5,000 Tasks)',
      tasks: 5000,
    },
    {
      ...commonProps,
      amount: 154800,
      interval: BillingInterval.year,
      id: planIds.PROFESSIONAL_10000_YEARLY,
      name: 'Professional (10,000 Tasks)',
      tasks: 10000,
    },
    {
      ...commonProps,
      amount: 23625,
      interval: BillingInterval.month,
      id: planIds.PROFESSIONAL_10000_MONTHLY,
      name: 'Professional (10,000 Tasks)',
      tasks: 10000,
    },
  ],
  planType: 'Professional',
};
